// Płeć konta (`gender` w /profile: male | female | null) — do odmiany komunikatów
// zwracających się do użytkownika („Jak spałeś?" / „Jak spałaś?"). Stan wspólny,
// więc zmiana w ustawieniach od razu przestawia teksty w całej aplikacji.
// Dopóki płeć nie jest wybrana, zostaje forma męska — jak było dotąd.
import { ref } from 'vue';
import { useApi } from '~/composables/useApi.ts';
import { t } from '@/i18n/index.js';

export const GENDERS = [
    { value: 'female', get label() { return t('settings.gender.female'); } },
    { value: 'male', get label() { return t('settings.gender.male'); } },
];

const gender = ref(null);
let pending = null;
let pendingToken = null;   // czyj profil — po zmianie konta pobieramy od nowa

export function useGender() {
    const api = useApi();
    const { token } = useAuth();

    const load = async (force = false) => {
        if (pending && !force && pendingToken === token.value) return pending;
        if (pendingToken !== token.value) gender.value = null;
        pendingToken = token.value;
        pending = api.get('/profile')
            .then((profile) => { gender.value = profile?.gender ?? null; })
            .catch(() => { /* bez profilu zostaje forma domyślna */ });
        return pending;
    };

    // Strona, która sama zapisała profil, podaje go tu, żeby nie pytać API drugi raz.
    const setFromProfile = (profile) => { gender.value = profile?.gender ?? null; };

    // byGender('Jak spałeś?', 'Jak spałaś?') — wybór formy według płci konta.
    const byGender = (male, female) => (gender.value === 'female' ? female : male);

    return { gender, load, setFromProfile, byGender };
}

// Okno „Uzupełnij dane" — otwiera je krok „Profil" ze Startu nowego konta; flaga żyje do zamknięcia.
export const useProfileSetup = () => useState('profile.setup', () => false);
